import { useContext } from 'react';
import { AppContext } from '~/providers/App';
import {
  getStatusIcon as agencyGetStatusIcon,
  getCuratedButtons as agencyGetCuratedButtons,
  getProjectCuratedButtons as agencyGetProjectCuratedButtons,
  getLogoSrc as agencyGetLogoSrc,
  getBreakpoints as agencyGetBreakpoints,
  getBrandColor as agencyGetBrandColor,
  getChakraColors as agencyGetChakraColors,
  getFonts as agencyGetFonts,
  getGlobalStyles as agencyGetGlobalStyles,
  getProviderSettings as agencyGetProviderSettings,
} from '@habity/agencies';
import { StatusType, ProviderType } from '@habity/types';

export const useAgency = () => {
  const { agency } = useContext(AppContext);
  const { providers, statuses, theme, settings, identifier } = agency || {};

  const publicStatuses =
    statuses?.filter((s) => s.show_publicly || s.show_public_preview) ?? [];
  const signedInStatuses = statuses?.filter((s) => s.show_signed_in) ?? [];

  const getStatusIcon = (status?: StatusType) => {
    return agencyGetStatusIcon(identifier, status);
  };

  const getCuratedButtons = (signedIn?: boolean) => {
    return agencyGetCuratedButtons(identifier, signedIn);
  };

  const getProjectCuratedButtons = () => {
    return agencyGetProjectCuratedButtons(identifier);
  };

  const getLogoSrc = () => {
    return agencyGetLogoSrc(identifier);
  };

  const getBreakpoints = () => {
    return agencyGetBreakpoints(identifier);
  };

  const getBrandColor = () => {
    return agencyGetBrandColor(identifier);
  };

  const getChakraColors = () => {
    return agencyGetChakraColors(identifier);
  };

  const getFonts = () => {
    return agencyGetFonts(identifier);
  };

  const getGlobalStyles = () => {
    return agencyGetGlobalStyles(identifier);
  };

  const getProviderSettings = (provider: ProviderType) => {
    return agencyGetProviderSettings(agency, provider);
  };

  const getIllustrationsRoute = (fileName: string) => {
    return identifier ? '/' + identifier + '/illustrations/' + fileName : '';
  };

  return {
    agency,
    providers,
    statuses,
    theme,
    settings,
    identifier,
    publicStatuses,
    signedInStatuses,
    getStatusIcon,
    getCuratedButtons,
    getProjectCuratedButtons,
    getLogoSrc,
    getBreakpoints,
    getBrandColor,
    getChakraColors,
    getFonts,
    getGlobalStyles,
    getProviderSettings,
    getIllustrationsRoute,
  };
};
